import {
  AbsatzProduktivitaet,
  AbsatzProduktivitaetEinstellungen,
  AbsatzVorgabe,
} from '@/domain/controlling/entities';
import { formatNumber } from './formatNumber';

function getDefaultValue(
  absatzProduktivitaetEinstellungen: AbsatzProduktivitaetEinstellungen,
  shouldUseDefaultFromEinstellungen: boolean,
) {
  return shouldUseDefaultFromEinstellungen
    ? formatNumber(
        absatzProduktivitaetEinstellungen.zielProduktivitaet.toString(),
        true,
      )
    : '';
}

// oxlint-disable-next-line complexity
export function getAbsatzProduktivitaetByMptOrStueck(
  absatzproduktivitaet: AbsatzProduktivitaet,
  absatzProduktivitaetEinstellungen: AbsatzProduktivitaetEinstellungen,
  shouldReturnDefaultFromEinstellungen?: boolean,
) {
  const shouldUseDefaultFromEinstellungen =
    shouldReturnDefaultFromEinstellungen ?? false;

  if (
    (absatzproduktivitaet?.stueck === undefined ||
      absatzproduktivitaet?.stueck === null) &&
    (absatzproduktivitaet?.mpt === undefined ||
      absatzproduktivitaet?.mpt === null)
  ) {
    return getDefaultValue(
      absatzProduktivitaetEinstellungen,
      shouldUseDefaultFromEinstellungen,
    );
  }

  if (
    absatzProduktivitaetEinstellungen.absatzVorgabe === AbsatzVorgabe.Stueck
  ) {
    if (
      absatzproduktivitaet.stueck === undefined ||
      absatzproduktivitaet.stueck === null
    ) {
      return getDefaultValue(
        absatzProduktivitaetEinstellungen,
        shouldUseDefaultFromEinstellungen,
      );
    }

    return formatNumber(absatzproduktivitaet.stueck.toString(), true);
  }

  if (
    absatzproduktivitaet.mpt === undefined ||
    absatzproduktivitaet.mpt === null
  ) {
    return getDefaultValue(
      absatzProduktivitaetEinstellungen,
      shouldUseDefaultFromEinstellungen,
    );
  }

  return formatNumber(absatzproduktivitaet.mpt.toString(), false);
}
